import type { ReactElement } from 'react';

import { useTheme } from '@emotion/react';
import { isNil } from 'ramda';

import { Typography } from '../typography';

import * as styles from './divider.styles';

export type TextBackground = 'primary' | 'secondary';

type Props = {
  text?: ReactElement;
  textBackground?: TextBackground;
  className?: string;
};

export const Divider = ({ className, text, textBackground = 'primary' }: Props) => {
  const theme = useTheme();

  if (!isNil(text)) {
    return (
      <div className={className} css={styles.textVariant} data-testid="divider">
        <hr css={styles.divider(theme)} />
        <Typography
          color="textTertiary"
          css={[styles.dividerText(theme), styles.dividerTextBackground[textBackground](theme)]}
          fontWeight="medium"
          variant="b4">
          {text}
        </Typography>
      </div>
    );
  }

  return <hr className={className} css={styles.divider(theme)} />;
};
